// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"79c4c8a579d6efa63c0c","655":"4c491213ac6fb5fc3374"}[chunkId] + ".js";
};